import PropTypes from "prop-types";
import React from "react";
import PriceBreakoutAccordion from "../../ConfirmTicketing/components/PriceBreakoutAccordion";
import { useSeriesShowContext } from "../SeriesShowApp";
import usePassQuote from "../usePassQuote";

const PassFeesSection = ({ idPrefix, enabled, price, roundUp, onRoundUpChange, taxIds }) => {
  const { series } = useSeriesShowContext();
  const { quote, error } = usePassQuote({ enabled, price, roundUp, taxIds });
  const roundUpId = `${idPrefix}-round-up`;

  return (
    <div className="mb-3" data-testid={`${idPrefix}-fees`}>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id={roundUpId}
          data-testid={roundUpId}
          checked={roundUp}
          onChange={() => onRoundUpChange(!roundUp)}
        />
        <label className="form-check-label" htmlFor={roundUpId}>
          Round Up: Increase the organizer fee to round the final cost to the nearest dollar
        </label>
      </div>
      {quote ? (
        <PriceBreakoutAccordion
          item={{ ...quote, base_price_two_decimals: quote.price }}
          accordionId={`${idPrefix}-breakdown`}
          currency={series.base_currency_symbol || "USD"}
          defaultOpen
          showCash={false}
        />
      ) : null}
      {error ? (
        <small className="text-danger d-block mt-2" role="alert" data-testid={`${idPrefix}-fees-error`}>
          {error}
        </small>
      ) : null}
    </div>
  );
};

PassFeesSection.propTypes = {
  idPrefix: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  roundUp: PropTypes.bool.isRequired,
  onRoundUpChange: PropTypes.func.isRequired,
  taxIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default PassFeesSection;
